<div fxLayout="column" class="page-layout simple fullwidth" fxFlex>
    <div class="content inner-scroll" fusePerfectScrollbar>
        <ng-container>
            <app-tab-selector></app-tab-selector>
            <!-- <app-shared-filters></app-shared-filters> -->
            <router-outlet></router-outlet>
        </ng-container>
    </div>
</div>
